import Store from 'lightningjs-redux';
import { getLayoutNavigation } from '../../../logic/layout/layout.selectors';
import { getProfileUsername, getProfilePhotoId, getSelectedProfile } from '../../../logic/user/user.selectors';

const mapControllers = instance => ({
  layoutNavigation: {
    selector: getLayoutNavigation,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.navigation = value;
    },
  },
  profileUsername: {
    selector: getProfileUsername,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.profileUsername = value;
    },
  },
  profileSelected: {
    selector: getSelectedProfile,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.selectedProfile = value;
    },
  },
  profilePhotoId: {
    selector: getProfilePhotoId,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.profilePhotoId = value;
    },
  },
});

export default Store.control(mapControllers);
